import TimeIntervalInput from './TimeIntervalInput';

export default TimeIntervalInput;
